module.exports = __webpack_public_path__ + "static/media/31JFA11.76865be8.jpg";